import { makeAutoObservable, runInAction } from 'mobx';

// Backend API URL from environment variable
const API_URL = process.env.REACT_APP_API_URL || 'https://bitrixapi.tmg-din-reestr.ru';

class ObjectStore {
  objects = [];
  loading = false;
  user = null;
  auth = null;

  constructor() {
    makeAutoObservable(this);
  }

  // Set data for headers
  setUser(user) {
    this.user = user;
  }

  setAuth(auth) {
    this.auth = auth;
  }

  setObjects(data) {
    this.objects = data;
  }

  getObjectById(id) {
    return this.objects.find((obj) => Number(obj.id) === Number(id));
  }

  // Getter for headers
  get headers() {
    return {
      'X-Bitrix-User': this.user,
      'X-Bitrix-Auth': this.auth,
      'Content-Type': 'application/json',
    };
  }

  // Get all objects
  async fetchObjects() {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/objects`, {
        headers: this.headers,
      });
      if (!res.ok) throw new Error(`Ошибка HTTP ${res.status}`);
      const data = await res.json();
      runInAction(() => {
        this.objects = data;
      });
    } catch (err) {
      console.error('Ошибка при загрузке объектов:', err);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Add object
  async addObject(payload) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/objects`, {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`Ошибка HTTP ${res.status}`);
      const data = await res.json();
      runInAction(() => {
        this.objects.push(data);
      });
    } catch (err) {
      console.error('Ошибка при добавлении объекта:', err);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Update object
  async updateObject(id, payload) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/objects/${id}`, {
        method: 'PUT',
        headers: this.headers,
        body: JSON.stringify(payload),
      });
      if (!res.ok) throw new Error(`Ошибка HTTP ${res.status}`);
      const updated = await res.json();
      runInAction(() => {
        const index = this.objects.findIndex((obj) => obj.id === id);
        if (index !== -1) this.objects[index] = updated;
      });
    } catch (err) {
      console.error('Ошибка при обновлении объекта:', err);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Delete object
  async deleteObject(id) {
    this.loading = true;
    try {
      const res = await fetch(`${API_URL}/objects/${id}`, {
        method: 'DELETE',
        headers: this.headers,
      });
      if (!res.ok) throw new Error(`Ошибка HTTP ${res.status}`);
      runInAction(() => {
        this.objects = this.objects.filter((obj) => obj.id !== id);
      });
    } catch (err) {
      console.error('Ошибка при удалении объекта:', err);
    } finally {
      runInAction(() => (this.loading = false));
    }
  }

  // Search by name
  filterObjects(searchText) {
    if (!searchText) return this.objects;
    return this.objects.filter((obj) =>
      obj.name.toLowerCase().includes(searchText.toLowerCase())
    );
  }
}

const objectStore = new ObjectStore();
export default objectStore;
